/**
 * VENDORIQ-PORTAL-5 (2026-09-27): axios's `settle()` RESOLVES a response whose
 * `status` is 0 (`if (!response.status || …) resolve(response)`). Firefox can end
 * an XHR that way (loadend, status 0, empty body) when the page is navigating or
 * the connection is torn down mid-request (a deploy's nginx reload -> 499). The
 * caller then gets `{ status: 0, data: '' }` as a SUCCESS, and every
 * `resp.data.data` unwrap yields `undefined`: ProductMetafieldsCard stored that as
 * its definitions and crashed on `defs.length`.
 *
 * A status-0 response is never a real server answer, so it is turned back into
 * the network error it actually is and every caller's existing catch handles it.
 */
import { AxiosError, type AxiosResponse } from 'axios';

export function rejectStatusZero<T extends Pick<AxiosResponse, 'status' | 'config' | 'request'>>(
  response: T,
): T | Promise<never> {
  if (response && response.status === 0) {
    return Promise.reject(
      new AxiosError(
        'Request ended without a response (status 0)',
        AxiosError.ERR_NETWORK,
        response.config,
        response.request,
      ),
    );
  }
  return response;
}
